<template>
    <div class="home pt-3">
        <b-breadcrumb>
            <b-breadcrumb-item active class="align-middle">
                <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                {{ $t("breadcrumb.departamentos") }}
            </b-breadcrumb-item>
            <b-button variant="secondary" @click="showModalNovoDepartamento()" class="ml-auto" size="sm">
                <b-icon-plus />{{ $t('botoes.novo-departamento') }}
            </b-button>
        </b-breadcrumb>


        <b-card class="mt-3" no-body>
            <b-table :items="departamentos" :fields="fields" responsive="sm" head-variant="light" sort-icon-left striped
                :current-page="currentPage" :per-page="perPage" hover show-empty class="mb-0" :emptyText="$t('global.table-empty')">
                <template #cell(Ações)="row">
                    <b-button size="sm" @click="showModalDepartamento(row.item)" variant="primary" class="mr-1">
                        <b-icon icon="pencil-fill"></b-icon> {{ $t('botoes.editar') }}
                    </b-button>
                </template>
            </b-table>
        </b-card>
        <b-row align-h="center" class="my-3">
            <b-col sm="5" md="2" class="my-1">
                <b-form-group>
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm">
                    </b-form-select>
                </b-form-group>
            </b-col>

            <b-col sm="7" md="2" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="departamentos.length" :per-page="perPage" align="fill"
                    size="sm" class="my-0"></b-pagination>
            </b-col>
        </b-row>
        <modal-carregando-geral />
        <modal-departamento @listaMudou="carregarDepartamentos()" :departamento="departamento" />
    </div>
</template>

<script>
import ModalCarregandoGeral from "@/components/modal/CarregandoGeral.vue";
import ModalDepartamento from "@/components/modal/Departamento.vue";
export default {
    name: "Departamentos",
    components: {
        ModalCarregandoGeral,
        ModalDepartamento
    },
    data() {
        return {
            departamento: {
                id: null,
                nome: null,
                email: null,
            },
            departamentos: [],
            fields: [
                { key: "descricao", sortable: true },
                { key: "Ações", label: this.$t('table.title.acoes'), sortable: false, class: 'text-right' },
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 15,
            pageOptions: [
                { value: 5, text: this.$t('paginacao.5-itens-por-pagina') },
                { value: 10, text: this.$t('paginacao.10-itens-por-pagina') },
                { value: 15, text: this.$t('paginacao.15-itens-por-pagina') },
                { value: 100, text: this.$t('paginacao.100-itens-por-pagina') },
            ],
        };
    },
    methods: {
        showModalNovoDepartamento() {
            this.departamento = {
                id: null,
                descricao: null,                
            };
            this.$bvModal.show("modal-departamento");
        },
        showModalDepartamento(item) {

            this.departamento = {
                id: item.id,
                descricao: item.descricao,                
                permissoes: item.permissoes,                
            };
            this.$bvModal.show("modal-departamento");
        },
        carregarDepartamentos() {
            this.$bvModal.show("modal-carregando-geral");
            this.$http
                .get("api/departamento")
                .then((response) => {
                    this.departamentos = response.data
                    this.$bvModal.hide("modal-carregando-geral");
                })
                .catch((errors) => {
                    console.log(errors);
                    this.$bvModal.hide("modal-carregando-geral");
                });
        },
    },
    mounted() {
        this.carregarDepartamentos()
    }
};
</script>

<style>

</style>